import React from "react";

export const autoTabHandler = (nextInputName: string, maxLength: number) => {
  return (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Tab") return;

    const target = e.currentTarget;
    const isPrintableCharacter = e.key.length === 1;

    if (target.value.length === maxLength && isPrintableCharacter) {
      const nextInput = document.querySelector<HTMLInputElement>(`input[name="${nextInputName}"]`);
      nextInput?.focus();
    }
  };
};
